/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} City_Select_Country_FirstInputs */



/**
* | output |
* | --- |
* | "Select a country first" |
*
* @param {City_Select_Country_FirstInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const city_select_country_first = /** @type {((inputs?: City_Select_Country_FirstInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<City_Select_Country_FirstInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez d'abord un pays")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione un país primero")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Selecione um país primeiro")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona prima una nazione")
	return /** @type {LocalizedString} */ ("Select a country first")
});